// ============================================================================
// <ForceLight> — pin a subtree to the light theme. CW-J Phase 2.
//
// Ben's decision 6 (2026-08-11): e-Sign is always light, whatever theme the
// user is in. It is the only surface people OUTSIDE the company ever see, and
// it renders a PDF onto a canvas — the document is white paper and always will
// be, so a dark frame around a white page reads as broken, and a signature
// drawn in black ink on a dark field is worse.
//
// HOW: `.force-light` in tcs.css re-declares the light channels. CSS custom
// properties inherit, so everything inside this element resolves light even
// with `.dark` on <html>. No component inside needs to know.
//
// ⚠️ CAVEAT: a React portal renders OUTSIDE this subtree and would not inherit.
// This app has no portals — every modal is a hand-rolled overlay rendered
// inline (see overlay-close.ts) — so the subtree approach holds today. If a
// portal is ever introduced on a signer-facing screen, this has to become a
// class toggled on <html> instead.
// ============================================================================

import type { ReactNode } from 'react';

export function ForceLight({ children }: { children: ReactNode }) {
  // min-h-full so the light background covers its container rather than just
  // the content box — otherwise a short document sits on a dark page. ⛔ NOT
  // min-h-screen: that is 100vh, which on iOS Safari with the toolbar showing
  // is TALLER than the 100dvh shell, so it forced a scrollbar on a page that
  // fits. Every caller is inside a scroll container that owns a height —
  // <main> in the shell, <PublicPage> outside it — so 100% is the right frame.
  return <div className="force-light min-h-full bg-tcs-bg-muted text-tcs-text">{children}</div>;
}
